import AppContext from "AppContext";
import { confirm } from "components/Confirmation";
import GeneralForm from "components/GeneralForm";
import { validate } from "components/validateGeneralForm";
import { hideLoading, showLoading } from "components/Loading";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody } from "reactstrap";
import comboService from "services/ComboService";
import ordemServicoService, { prioridadesOrdemServicoList } from "services/OrdemServicoService";
import { PapelEnum } from "services/PerfilService";
import { TipoContratoEnum } from "services/ContratoService";
import { erroInesperado } from "services/Utils";

export function ModalIncluirManual({ config, onClosed, onChange }) {
  const [data, setData] = useState({})
  const [contratos, setContratos] = useState([])
  const { state } = useContext(AppContext)
  const navigate = useNavigate()

  const idTipoPerfil = state?.user?.perfil?.idTipo || 0
  const usaContratoDoState = idTipoPerfil == PapelEnum.FISCAL || idTipoPerfil == PapelEnum.GESTOR_CONTRATO

  useEffect(() => {
    if (!config) return

    setData({ idContrato: usaContratoDoState ? state?.contrato?.id : null })

    if (!usaContratoDoState) {
      comboService.contrato().then(res => {
        if (res.success) {
          setContratos(res.data.filter(el => el.tipoContrato == TipoContratoEnum.NORMAL))
        } else {
          setContratos([])
        }
      })
    }
  }, [config])

  const formConfig = [
    [
      {
        name: "idContrato",
        label: "Contrato",
        type: "combo",
        required: true,
        colspan: 12,
        hide: usaContratoDoState,
        showDefault: true,
        options: contratos,
        optionValue: "id",
        optionLabel: "numero",
      },
    ],
    [
      {
        name: "numero",
        label: "Número da OS",
        type: "integer",
        required: true,
        colspan: 4,
      },
      {
        name: "data",
        label: "Data",
        type: "date",
        required: true,
        colspan: 4,
      },
      {
        name: "numeroProjeto",
        label: "Número do Projeto",
        type: "text",
        required: true,
        colspan: 4,
      },
    ],
    [
      {
        name: "us",
        label: "US",
        type: "text",
        required: false,
        colspan: 4,
      },
      {
        name: "prazo",
        label: "Prazo de Execução",
        type: "date",
        required: true,
        colspan: 4,
      },
      {
        name: "prioridade",
        label: "Prioridade",
        type: "combo",
        required: false,
        colspan: 4,
        showDefault: true,
        defaultValue: "Sem prioridade",
        options: prioridadesOrdemServicoList.map(p => ({ value: p, label: p })),
      },
      {
        name: "dicaPrioridade",
        type: "view",
        colspan: 12,
        hide: !!data.prioridade,
        component: () => (
          <small className="text-muted d-block text-right mt--2 mb-2">
            Sem prioridade, a previsão de início segue a regra da P-3.
          </small>
        ),
      },
    ],
    [
      {
        name: "local",
        label: "Local",
        type: "text",
        required: false,
        colspan: 12,
      },
    ],
  ]

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const handleSubmit = (ev) => {
    ev.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    confirm({
      header: "Inclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          showLoading()
          const res = await ordemServicoService.criarManual({
            idContrato: usaContratoDoState ? state?.contrato?.id : data.idContrato,
            numero: data.numero,
            data: data.data,
            numeroProjeto: data.numeroProjeto,
            us: data.us,
            local: data.local,
            prazo: data.prazo,
            prioridade: data.prioridade,
          })
          hideLoading()
          if (res.success) {
            toast("A Ordem de Serviço foi criada com sucesso!")
            onChange && onChange()
            onClosed && onClosed()
            navigate(`/admin/ordens_servico/${res.data}`)
          } else {
            toast("Erro ao criar a Ordem de Serviço")
          }
        } catch (ex) {
          hideLoading()
          if (ex.status == 422 || ex.status == 400) {
            toast(ex.response.data.message || "Erro ao criar a Ordem de Serviço")
          } else {
            erroInesperado()
          }
        }
      }
    })
  }

  return (
    <Modal isOpen={!!config} onClosed={onClosed} size="lg">
      <ModalBody>
        <h2>Incluir Ordem de Serviço</h2>
        <hr />
        {config && (
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
            />

            <div className="row mt-3">
              <div className="col-12">
                <Button color="primary" type="submit">Incluir</Button>
                <Button color="primary" onClick={onClosed} outline>Cancelar</Button>
              </div>
            </div>
          </form>
        )}
      </ModalBody>
    </Modal>
  )
}
